import { Form } from "react-bootstrap"

export default function EstadoSelect({register, name}) {
    return <Form.Select {...register(name)}>
        <option value="A">Activo</option>
        <option value="I">Inactivo</option>
    </Form.Select>
}